// The values here have to match with the ones in the api.
export default {
  STATUS_UNREAD: 1,
  STATUS_READ: 2,
};